class StcGiftMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.stcReady === 'true') return;
    this.dataset.stcReady = 'true';

    this.parentView = this.querySelector('[data-stc-gift-parent-view]');
    this.childView = this.querySelector('[data-stc-gift-child-view]');
    this.parents = Array.from(this.querySelectorAll('[data-stc-gift-parent]'));
    this.panels = Array.from(this.querySelectorAll('[data-stc-gift-panel]'));

    this.parents.forEach((parent) => {
      parent.addEventListener('click', () => this.openCategory(parent));
    });

    this.querySelectorAll('[data-stc-gift-back]').forEach((back) => {
      back.addEventListener('click', () => this.showParents());
    });

    this.querySelectorAll('a[href*="#"]').forEach((link) => {
      link.addEventListener('click', (event) => this.followAnchor(event, link));
    });

    this.closest('details')?.addEventListener('toggle', (event) => {
      if (!event.currentTarget.open) this.showParents(false);
    });
  }

  openCategory(activeParent) {
    const target = activeParent.dataset.stcGiftParent;
    this.activeParent = activeParent;

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.stcGiftPanel === target;
      panel.hidden = !isActive;
    });

    this.parents.forEach((parent) => {
      parent.setAttribute('aria-expanded', String(parent === activeParent));
    });

    this.parentView.hidden = true;
    this.childView.hidden = false;
    this.panels.find((panel) => panel.dataset.stcGiftPanel === target)
      ?.querySelector('[data-stc-gift-back]')
      ?.focus();
  }

  showParents(restoreFocus = true) {
    this.panels.forEach((panel) => { panel.hidden = true; });
    this.parents.forEach((parent) => parent.setAttribute('aria-expanded', 'false'));
    this.childView.hidden = true;
    this.parentView.hidden = false;
    if (restoreFocus) this.activeParent?.focus();
  }

  followAnchor(event, link) {
    const destination = new URL(link.href, window.location.href);
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const destinationPath = destination.pathname.replace(/\/$/, '');
    if (!destination.hash || destinationPath !== currentPath) return;

    const target = document.querySelector(destination.hash);
    if (!target) return;

    event.preventDefault();
    this.closest('details')?.removeAttribute('open');
    window.history.pushState(null, '', destination.hash);
    window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  }
}

if (!customElements.get('stc-gift-menu')) {
  customElements.define('stc-gift-menu', StcGiftMenu);
}

function bindStcMobileAccordions(root = document) {
  root.querySelectorAll('[data-stc-mobile-accordions]').forEach((container) => {
    if (container.dataset.stcReady === 'true') return;
    container.dataset.stcReady = 'true';

    container.querySelectorAll(':scope > details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        container.querySelectorAll(':scope > details[open]').forEach((sibling) => {
          if (sibling !== details) sibling.removeAttribute('open');
        });
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => bindStcMobileAccordions());
document.addEventListener('shopify:section:load', (event) => bindStcMobileAccordions(event.target));
